"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ToolTip;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ToolTip(_ref) {
  var children = _ref.children;

  return (
    // XXX: Ugly inherited code from the original HTML.
    _react2.default.createElement(
      "div",
      { className: "tooltip" },
      _react2.default.createElement(
        "div",
        { className: "panel-tooltip" },
        _react2.default.createElement(
          "div",
          { className: "media-bottom" },
          _react2.default.createElement(
            "div",
            { className: "plan-details-info" },
            _react2.default.createElement(
              "div",
              { className: "detail-paragraph" },
              _react2.default.createElement(
                "div",
                { className: "detail-paragraph-box" },
                children
              )
            )
          )
        )
      )
    )
  );
} // ToolTip
//
// Receive arbitrary DOM elements and then put it in a ToolTip.
//


ToolTip.propTypes = {
  children: _react2.default.PropTypes.node.isRequired
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolTip.js
// module id = 1230
// module chunks = 0